module.exports = __webpack_public_path__ + "cement/img/fagai.5d5f5388.png";